import { isProduction } from "@/Environment";
import {
  calculateOpenAiConversionAmountCents,
  emailSha256LowercaseHex,
} from "@/Helpers/openAiAdsHelpers";

// Created in ads.openai.com -> Conversions. Must match the loader snippet in
// index.html and the www install (marketing/apps/www/src/scripts/openai-pixel.ts).
const OPENAI_PIXEL_ID = "QHn7pNYTQaJfhbCBfgD1hL";

declare global {
  interface Window {
    oaiq?: (...args: unknown[]) => void;
  }
}

export function useOpenAiAdsConversions() {
  // Signup conversion: registration_completed
  // https://developers.openai.com/ads/measurement-pixel
  async function onAccountCreated(
    shipmentFrequency: string | undefined,
    email: string,
  ) {
    if (!isProduction()) {
      return;
    }

    try {
      // Re-init with hashed email so OpenAI can match the conversion to a user
      window.oaiq?.("init", {
        pixelId: OPENAI_PIXEL_ID,
        user: { email_sha256: await emailSha256LowercaseHex(email) },
      });

      window.oaiq?.("measure", "registration_completed", {
        type: "customer_action",
        amount: calculateOpenAiConversionAmountCents(shipmentFrequency),
        currency: "CAD",
      });
    } catch (e) {
      console.warn("Error in openai pixel", { e });
    }
  }

  return {
    onAccountCreated,
  };
}
